import React, { PureComponent } from 'react'
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class InformacionAduaneraForm extends PureComponent {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      numero: ['required', 'string', 'min:1'],
      fecha: ['required'],
      aduana: ['string', 'min:1'],
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.data && !!this.props.data && !!this.props.data.id && !this.state.data.id) {
      this.handleOnChange({
        ...this.props.data,
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnAdd = () => {
    const { data } = this.state;

    const newData = {
      ...data,
    }

    this.props.onAdd(newData);

    this.setState({
      data: {},
      isValid: false,
    });

    this.validate({});
  }

  render() {
    const { data, isValid } = this.state;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número"
              name="numero"
              placeholder=""
              help=""
              minLength="1"
              rules={ rules.numero }
              value={ data.numero }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="date-picker"
              id="fecha"
              label="Fecha"
              name="fecha"
              rules={ rules.fecha }
              value={ data.fecha }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Aduana"
              name="aduana"
              placeholder=""
              help=""
              minLength="1"
              rules={ rules.aduana }
              value={ data.aduana }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default InformacionAduaneraForm;